import React from "react"
import { t, Trans } from "@lingui/macro"
import { Alert } from "./Alert"

const ConfirmAlert = (props) => (
  <Alert description={<Trans>Are you sure you wish to perform this action?</Trans>} okLabel={t`Confirm`} {...props} />
)

export { ConfirmAlert }
